import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { PatchBodyBankAccountQueryType } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyBankAccount/patchBodyBankAccountQuery.type';
import { patchBodyBankAccountFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyBankAccount/patchBodyBankAccountQueryFunction';

export const patchBodyBankAccountQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchBodyBankAccountQueryType
> => ({
  mutationKey: ['patch-Body-Bank-Account'],
  mutationFn: (params: PatchBodyBankAccountQueryType) =>
    patchBodyBankAccountFunction(params),
});
